<template>
  <div class="mb-4">
    <h3 class="mt-4">
      {{ $t('Related users') }}
    </h3>
    <dx-data-grid
      ref="relatedUsersGrid"
      :data-source="relatedUserList"
      :on-editor-preparing="onEditorPreparing"
      :show-borders="true"
      @toolbar-preparing="onToolbarPreparing"
    >
      <dx-column
        data-field="user_id"
        :caption="$t('Username')"
      >
        <dx-lookup
          :data-source="commonUserList"
          value-expr="id"
          display-expr="username"
        />
      </dx-column>
      <dx-column
        data-field="user.first_name"
        :caption="$t('First name')"
        :allow-editing="false"
      />
      <dx-column
        data-field="user.last_name"
        :caption="$t('Last name')"
        :allow-editing="false"
      />
      <dx-editing
        v-if="user.is_manager"
        :allow-adding="true"
        :allow-deleting="true"
        :use-icons="true"
        mode="row"
      />
    </dx-data-grid>
  </div>
</template>

<script>
import { DxDataGrid, DxColumn, DxEditing, DxLookup } from 'devextreme-vue/data-grid';

import { mapState } from 'vuex';
import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale as localize, loadMessages } from 'devextreme/localization';

import createCustomStore from '@/utils/create-custom-store';

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxLookup,
  },
  props: {
    id: [String, Number],
  },
  data: vm => ({
    relatedUserList: createCustomStore(`/profile/api/companies/${vm.id}/related_users/`),
    commonUserList: createCustomStore('/profile/api/users/'),
  }),
  computed: {
    ...mapState(['user']),
  },
  created() {
    loadMessages(ruMessages);
    localize(this.$i18n.locale);
  },
  methods: {
    onToolbarPreparing(e) {
      e.toolbarOptions.items.unshift({
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'ace-icon icon-refresh',
          onClick: this.refreshDataGrid.bind(this),
        },
      }, {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'ace-icon icon-close',
          hint: this.$t('clear_filters'),
          onClick: this.clearFilter.bind(this),
        },
      });
    },
    refreshDataGrid() {
      this.$refs.relatedUsersGrid.instance.refresh();
    },
    clearFilter() {
      this.$refs.relatedUsersGrid.instance.clearFilter();
    },
    onEditorPreparing: e => {
      const component = e.component;
      const rowIndex = e.row && e.row.rowIndex;
      if (e.dataField === 'user_id') {
        const onValueChanged = e.editorOptions.onValueChanged;
        e.editorOptions.onValueChanged = evt => {
          setTimeout(() => {
            const user = e.lookup.items.find(it => it.id === evt.value);
            onValueChanged.call(this, evt);
            component.cellValue(rowIndex, 'user.first_name', user.first_name);
            component.cellValue(rowIndex, 'user.last_name', user.last_name);
          }, 0);
        };
      }
    },
  },
};
</script>
